import * as React from 'react';
import { BookingListSummaryDto } from 'Util/_HumanWritten/Bookings/FetchBookingsWithFilters';
import { LottieSpinner } from 'Views/Components/_HumanWritten/Lottie/LottieSpinner';
import { BookingCard } from '../BookingCard';
import { Button, Colors, Display } from 'Views/Components/Button/Button';
import BoatImg from 'images/no-results.png';

export interface BookingListTabProps {
	bookingList: BookingListSummaryDto[] | null;
	loading: boolean;
	showSeeMoreButton: boolean;
	onSeeMoreClick: () => void;
	extraCards?: React.ReactNode;
}

export function BookingListTab({
	bookingList,
	loading,
	showSeeMoreButton,
	onSeeMoreClick,
	extraCards,
}: BookingListTabProps) {
	if (bookingList === null) {
		return <LottieSpinner />;
	}

	const hasBookings = bookingList.length > 0;
	const hasExtra = !!extraCards;

	if (hasBookings || hasExtra) {
		return (
			<>
				{bookingList.map((booking: BookingListSummaryDto) => (
					<BookingCard key={booking?.id} booking={booking} editUrl={`/bookings/${booking?.id}`} />
				))}
				{extraCards}
				{hasBookings && showSeeMoreButton && (
					<Button
						key="button"
						className="see-more-button"
						onClick={onSeeMoreClick}
						display={Display.Solid}
						colors={Colors.Secondary}
						disabled={loading}
					>
						{loading ? 'Loading...' : 'See more'}
					</Button>
				)}
			</>
		);
	}

	return (
		<div className="no-bookings-to-show">
			<img src={BoatImg} alt="no-results" />
			<h6>Nothing to see here</h6>
		</div>
	);
}
